import { Module } from 'vuex';
import { RootState, StreakNotificationType } from 'frontend/types';

interface StreakPopupState {
  streakPopupVisible: boolean;
  streakNotificationType: StreakNotificationType;
}

const INITIAL_STATE: StreakPopupState = {
  streakPopupVisible: false,
  streakNotificationType: 'none',
};

const streakPopup: Module<StreakPopupState, RootState> = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    setValue(state: StreakPopupState, value: StreakPopupState) {
      Object.assign(state, value);
    },
  },
  actions: {
    showNotification({ commit }, notificationType: StreakNotificationType): void {
      const newState: StreakPopupState = {
        streakPopupVisible: true,
        streakNotificationType: notificationType,
      };
      commit('setValue', newState);
    },
    showPopup({ commit }): void {
      const newState: StreakPopupState = {
        streakPopupVisible: true,
        streakNotificationType: 'none',
      };
      commit('setValue', newState);
    },
    hidePopup({ commit }): void {
      commit('setValue', INITIAL_STATE);
    },
  },
};

export default streakPopup;
